import Immutable from 'seamless-immutable';

import { oneItemStateChange } from './utils';

import { formatDate } from 'helpers/dateUtils';

const answersReducer = (acc, answer) => {
  const { active = true } = answer;
  if (active) {
    const { qAItemId, text, displayName, timeStamp, upVotes, downVotes } = answer;
    acc.push({
      key: qAItemId,
      text,
      author: displayName,
      date: formatDate('MMMM D, YYYY', new Date(timeStamp * 1000)), // timeStamp is unix seconds and we need ms for date constructor
      upvotes: upVotes,
      downvotes: downVotes,
      best: false,
      myVote: 0,
      justReported: false
    });
  }
  return acc;
};

const processAnswers = answers => {
  if (answers.length !== 0) {
    answers[0].best = true;
  }
  return answers;
};

const questionsReducer = (acc, question) => {
  const { active = true, qAItemId, text, score } = question;
  const qAItemsList = question.qAItemsList || [];
  if (active) {
    acc.push({
      key: qAItemId,
      text,
      votes: score,
      answers: processAnswers(qAItemsList.reduce(answersReducer, [])),
      answersCollapsed: true,
      myVote: 0,
      justReported: false,
      answering: false
    });
  }
  return acc;
};

function modifyStateWithNewQuestion(state, question) {
  // newQuestion is an array of 0 or 1 question(s)
  const newQuestion = questionsReducer([], question);
  return Immutable.set(state, 'questions', newQuestion.concat(state.questions));
}

function modifyStateWithNewAnswer(state, questionKey, answer) {
  return oneItemStateChange(state, questionKey, question => {
    // newAnswer is a list of 0 or 1 answer(s)
    const newAnswer = answersReducer([], answer);
    const newAnswers = Immutable.asMutable([].concat(question.answers, newAnswer), { deep: true });
    newAnswers[0].best = false;
    return Immutable.set(question, 'answers', processAnswers(newAnswers));
  });
}

export function modifyStateWithNewItem(state, questionKey, item) {
  if (questionKey) {
    return modifyStateWithNewAnswer(state, questionKey, item);
  } else {
    return modifyStateWithNewQuestion(state, item);
  }
}

export function processQuestionsAndAnswers(data) {
  const questions = data.qAItemsList.reduce(questionsReducer, []);
  return {
    questions,
    questionsCollapsed: true,
    viewingQuestionsDesktop: true,
    authenticated: false
  };
}
